import { verificarUsuario } from "../api/auth.api";

/** Guard de rutas: valida el token contra el código de pantalla. Devuelve `autenticado`. */
export const validarAutenticacion = async (token: string, codigo: string): Promise<boolean> => {
  const dataPOST = { token, codigo };
  const { autenticado } = await verificarUsuario(dataPOST);
  return autenticado;
};
